// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as MarkdownCodeExtended } from '../../../assets/icons/extended/markdown/markdown-code.svg?react';
import { createIcons } from '../../Icon';
const MarkdownCodeIcon = /* @__PURE__ */ createIcons('MarkdownCode', {
    extended: MarkdownCodeExtended
});
MarkdownCodeIcon.supportedTypes = ['extended'];
MarkdownCodeIcon.category = 'markdown';
export default MarkdownCodeIcon;
